// extracted by mini-css-extract-plugin
export default {"body":"dark_body__aftNr","text":"dark_text__wx2oM","overflow":"dark_overflow__564zv","circle":"dark_circle__VWjz5 color_colorDarkBackground__VTGL5"};